export default __webpack_public_path__ + "static/media/closure-of-trading-window-1.dd1c97ce.pdf";